// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__19eN7"};